import React, { Fragment, useState, useEffect } from "react";
import "./styles.css";

import { ReactComponent as TickIcon } from "common/assets/svg/tickIconOffer.svg";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import { useSpring, useTransition, animated } from "react-spring";
import { useHistory, useParams, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "common/rootReducer";
import { setCartAuthPending } from "common/features/cart/cartActions";
// import SignIn from "pages/authPages/signIn";
// import PopupSign from "components/prompts/loginPromt/PopupSign"
// import SignUp from "pages/authPages/signUp";
import InnerSignup from "../innerSignup";
import { dialogOpen } from "common/features/navigation/navigationActions";
function SignupPopup(props: any) {
  const dispatch = useDispatch();
  const location = useLocation<any>();

  const {
    isOpen,
    visible,
    title,
    subtext,
    cartUrl,
    setGuestPopup,
    setloginRequestPopup
    // setIsOpen,
  } = props;
  const history = useHistory();
 // const [loginRequestPopup, setloginRequestPopup] = useState(false);

  const [user, setUser] = useState({ email: "", password: "" });
  const [signUp, setSignUp] = useState(false);
  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setUser({ ...user, [name]: value })
  // }

  const handleClick = () => {
    // setOpen(!open)
    setloginRequestPopup(true);
  };
  const opacityProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: isOpen ? 1 : 0 },
    backgroundColor: "green",
  });

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)" },
    enter: { transform: "translate3d(0,0px,0)" },
    leave: { transform: "translate3d(0,-15px,0)" },
    unique: true,
  });

  const handleSubmit = () => {
    console.log(user, "user");
  };

  const handleSignUp = () => {
    setSignUp(!signUp);
  };

  const ColoredLine = () => <hr className="bottomLine" />;

  return (
    <Fragment>
      {isOpen ? (
        <Fragment>
          <div id="modal-background"></div>
          <animated.div className="CPWrapper" style={opacityProps}>
            {transitions.map(({ item, key, props }) =>
              item ? (
                <animated.div
                  className="CPContainer"
                  key={key}
                  //  style={props}
                  style={{
                    backgroundColor: "#EDEDED",
                    width: 430,
                    maxHeight: "80vh",
                    overflowX: "hidden",
                    overflowY: "auto",
                    position: "relative",
                    paddingTop: "0",
                    paddingLeft: "0",
                    paddingRight: "0",
                  }}
                >
                  <div className="newAccount">
                    <span id="return-back-popup">
                      <BackIcon
                        onClick={() => {
                          visible(true);
                          dispatch(dialogOpen(false));
                        }}
                        className="darkBackIcon"
                      />
                    </span>
                    <span className="title-texts">New account</span>
                    <Cancel
                      onClick={() => {
                        visible(true);
                        dispatch(dialogOpen(false));
                      }}
                      className="cancelDes"
                    />
                    <div>
                      <ColoredLine />
                    </div>
                  </div>
                  <div>
                    <InnerSignup
                      onClose={visible}
                      visible={visible}
                      setGuestPopup={setGuestPopup}
                      setloginRequestPopup={setloginRequestPopup}
                    />
                  </div>
                </animated.div>
              ) : null
            )}
          </animated.div>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

export default SignupPopup;
